export default __webpack_public_path__ + "static/media/videoConfe.87ca9417.png";